module.exports = __webpack_public_path__ + "img/img1.ad5ce191.png";